import AddMediaModalWrapper from 'components/AddMediaModalWrapper/AddMediaModalWrapper'

export default AddMediaModalWrapper
